<app-shared-loading *ngIf="loading"></app-shared-loading>
<ng-container *ngIf="isGUtransfer else defaultMethods" >
  <h1 class="center">{{ 'cashTransferTitle' | translation | async }}</h1>
  <app-payment-expiration [expiration]="transaction.EXPIRATION"></app-payment-expiration>
  <div class="methodForm">
    <p innerHTML="{{ 'deposit-RefPago-bam' | translation | async }}"></p>
    <app-copy-to-clipboard [value]="rc_number" [idleEnable]="false"></app-copy-to-clipboard>
    <p innerHTML="{{'reference-new' | translation | async }}"></p>
    <app-copy-to-clipboard [value]="'Payvalida Guatemala S.A'" [idleEnable]="false"></app-copy-to-clipboard>
    <div>
      <p>{{ 'deposit-EmailInfo' | translation | async }}</p>
      <form [formGroup]="emailForm" autocomplete="off">
        <mat-form-field appearance="outline" [ngClass]=" { disabledInput: isControlReadOnly('email') }">
          <mat-label>{{ 'forms-Email-Input' | translation | async }}</mat-label>
          <input type="email" matInput name="email" placeholder="{{ 'forms-Email-Input' | translation | async }}"
                 maxlength="40" formControlName="email" [readonly]="isControlReadOnly('email')" />
          <mat-error *ngIf=" !emailForm.valid && emailForm.get('email').touched">
            <div *ngIf="emailForm.get('email').errors?.required"
                 innerHTML="{{ 'forms-EmailRequired' | translation | async }}"></div>
            <div *ngIf="emailForm.get('email').errors?.pattern">{{ 'forms-EmailInvalid' | translation | async }}</div>
          </mat-error>
        </mat-form-field>
      </form>
    </div>
      <app-privacy-conditions (formPrivacyUpdate)="formPrivacyUpdate($event)"></app-privacy-conditions>
    <div class="otherInfo">
      <p innerHTML="{{ 'deposit-RefPago-bam-info-time' | translation | async }}"></p>
    </div>
</div>
</ng-container>
<ng-template #defaultMethods>
  <h1 *ngIf="isLafiseTransfer else othersPayMethods" class="center">{{ 'transfer-title-lafise-bank' | translation | async }}</h1>
  <app-payment-expiration [expiration]="transaction.EXPIRATION"></app-payment-expiration>
  <ng-template #othersPayMethods>
    <h1 class="center">{{ 'cashTransferTitle' | translation | async }}</h1>
  </ng-template>
<div class="methodForm">
  <app-counter-item>
    <p innerHTML="{{ 'cashTransferReference' | translation | async }}"></p>
    <app-copy-to-clipboard [value]="transaction.ORDER_REFERENCE" [idleEnable]="false"></app-copy-to-clipboard>
  </app-counter-item>
  <app-counter-item>
    <p innerHTML="{{ 'cashTransferConcept' | translation | async }}"></p>
    <app-copy-to-clipboard [value]="currentConcept?.number" [idleEnable]="false"></app-copy-to-clipboard>
  </app-counter-item>
  <app-counter-item>
    <p innerHTML="{{ 'cashTransferAccountInfo' | translation | async }}"></p>
    <app-copy-to-clipboard [value]="getValCashAccInfo()" [idleEnable]="false"></app-copy-to-clipboard>
  </app-counter-item>
  <app-counter-item>
    <div>
      <p>{{ 'deposit-EmailInfo' | translation | async }}</p>
      <form [formGroup]="emailForm" autocomplete="off">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'forms-Email-Input' | translation | async }}</mat-label>
          <input type="email" matInput name="email" placeholder="{{ 'forms-Email-Input' | translation | async }}"
                 maxlength="40" formControlName="email"/>
          <mat-error *ngIf=" !emailForm.valid && emailForm.get('email').touched">
            <div *ngIf="emailForm.get('email').errors?.required"
                 innerHTML="{{ 'forms-EmailRequired' | translation | async }}"></div>
            <div *ngIf="emailForm.get('email').errors?.pattern">{{ 'forms-EmailInvalid' | translation | async }}</div>
          </mat-error>
        </mat-form-field>
      </form>
    </div>
  </app-counter-item>
  <app-privacy-conditions (formPrivacyUpdate)="formPrivacyUpdate($event)"></app-privacy-conditions>
  <div class="otherInfo">
    <p innerHTML="{{ 'cashTransferAproveTime' | translation | async }}"></p>
  </div>
</div>
</ng-template>


